// extracted by mini-css-extract-plugin
export default {"cta":"ZE-z","disabled":"_E-z"};